<div class="container">
  <div class="d-flex flex-column">
    <h1 class="text-secondary text-center">
      Désolé, nous n'avons pas trouvé la page à laquelle vous tentez d'accéder.
      <a routerLink="/dashboard">Accueil</a>
    </h1>
  </div>
</div>
